import { formatDate } from '@/utils'

export default {
  recentlyAddedUsersLoading:
    state => state.recentlyAddedUsersLoading,
  recentlyAddedUsersMessage:
    state => state.recentlyAddedUsersMessage,
  recentlyAddedUsers: state => {
    return state.recentlyAddedUsers.map(u => ({
      userName: `${u.firstName} ${u.lastName}`,
      userId: u.userId,
      email: u.email,
      date: formatDate(u.createdDate)
    }))
  },

  recentlyUpdatedUsersLoading:
    state => state.recentlyUpdatedUsersLoading,
  recentlyUpdatedUsersMessage:
    state => state.recentlyUpdatedUsersMessage,
  recentlyUpdatedUsers: state => {
    return state.recentlyUpdatedUsers.map(u => ({
      userName: `${u.firstName} ${u.lastName}`,
      userId: u.userId,
      email: u.email,
      date: formatDate(u.modifiedDate)
    }))
  },

  pendingUsersLoading:
    state => state.pendingUsersLoading,
  pendingUsersMessage:
    state => state.pendingUsersMessage,
  pendingUsers: state => {
    return state.pendingUsers.map(u => ({
      userName: `${u.firstName} ${u.lastName}`,
      userId: u.userId,
      email: u.email,
      date: formatDate(u.createdDate)
    }))
  }
}
